import {connect} from 'react-redux'
import type {EntryPointProps} from 'react-relay'

import type {State} from '../../../reducers/types'
import {getAllProjectsReady} from '../../../selectors'
import {
  getCanShowAllProjects,
  getHasFavoriteProjects,
  getProjectsData,
} from '../../../selectors/projectTrees'
import type {ProjectPageEntryPoint} from '../ProjectPage/ProjectPage.entryPoint'

import FavoriteProjectsPage from './FavoriteProjectsPage'
import type {StateProps} from './FavoriteProjectsPage.types'

const mapStateToProps = (state: State): StateProps => ({
  hasProjects: getProjectsData(state).length > 0,
  canShowAllProjects: getCanShowAllProjects(state),
  hasFavoriteProjects: getHasFavoriteProjects(state),
  projectsLoaded: getAllProjectsReady(state),
})

type NestedEntryPoints = {
  main: typeof ProjectPageEntryPoint
}

const FavoriteProjectsPageContainer = connect(mapStateToProps)(FavoriteProjectsPage)

export default function FavoriteProjectsPageOuterContainer({
  entryPoints,
}: EntryPointProps<{}, NestedEntryPoints, {}, {}>) {
  return <FavoriteProjectsPageContainer entryPoint={entryPoints.main} />
}
export type FavoriteProjectsPageOuterContainerComponent = typeof FavoriteProjectsPageOuterContainer
